import React, { useState, useEffect } from "react";

const DragAndDropDocument = ({
  onImagesUpdate,
  uploadedImages,
  accept = "image/*",
  showPic = 3,
}) => {
  const [images, setImages] = useState([]);
  const [visibleImages, setVisibleImages] = useState([]);
  const [imageIndex, setImageIndex] = useState(showPic);

  // Sort and initialize images
  useEffect(() => {
    const sortedImages = [...uploadedImages].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    setImages(sortedImages);
    setVisibleImages(sortedImages.slice(0, showPic));
  }, [uploadedImages, showPic]);

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addImages(e.dataTransfer.files);
  };

  const handleFileChange = (e) => {
    addImages(e.target.files);
  };

  const addImages = (files) => {
    if (!files.length) return;

    const allowedExtensions = accept
      .split(",")
      .map((ext) => ext.trim().toLowerCase());
    const newImages = [];
    const errors = [];

    Array.from(files).forEach((file) => {
      const isAllowed = allowedExtensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext)
      );

      if (!isAllowed) {
        errors.push(`"${file.name}" is not an allowed file type.`);
      } else if (!images.some((img) => img.file?.name === file.name)) {
        newImages.push({
          file,
          preview: file.type.startsWith("image/")
            ? URL.createObjectURL(file)
            : null,
          name: file.name,
          url: null,
          created_at: new Date().toISOString(),
        });
      }
    });

    if (errors.length) {
      alert(errors.join("\n"));
      return;
    }

    if (newImages.length > 0) {
      const updatedImages = [...newImages, ...images].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      setImages(updatedImages);
      setVisibleImages(updatedImages.slice(0, imageIndex));
      onImagesUpdate?.(updatedImages);
    }
  };

  return (
    <div onDrop={handleDrop} onDragOver={(e) => e.preventDefault()}>
      <input
        type="file"
        accept={accept}
        multiple
        onChange={handleFileChange}
        className="hidden"
        id="fileInput"
      />
      <label
        htmlFor="fileInput"
        className="cursor-pointer truncate font-medium dark:text-black dark:button-primary-gradient text-sm rounded-md bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] text-dark dark:button-primary-gradient px-4 py-2 mt-2"
      >
        Browse Files
      </label>
    </div>
  );
};

export default DragAndDropDocument;
